"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const FormattedNumber_1 = __importDefault(require("components/design-system/FormattedNumber"));
const MultipleChoice = ({ colorTheme, pollOptions, voterCount }) => {
    const circleCssQuery = () => {
        const cssQuery = [];
        const previousPercen = [];
        const previousSumCount = (arr) => {
            return arr.reduce((partialSum, a) => partialSum + a, 0);
        };
        const percentageCount = pollOptions.map(({ count }) => count === 0 ? 0 : (count / voterCount) * 100);
        percentageCount.map((percen, index) => {
            cssQuery.push(`var(--${colorTheme[index]}-400) ${index === 0
                ? `0% ${percen}%`
                : `${previousSumCount(previousPercen)}% ${previousSumCount([
                    ...previousPercen,
                    percen
                ])}%`}`);
            percen !== 0 && previousPercen.push(percen);
        });
        return cssQuery.toString();
    };
    return (react_1.default.createElement("div", { className: "flex items-center p-[16px] bg-n-200 rounded-[4px]" },
        react_1.default.createElement("div", { className: "w-[200px] h-[200px] rounded-[50%] pr-[200px] origin-center overflow-hidden", style: voterCount !== 0
                ? {
                    background: `conic-gradient(${circleCssQuery()})`,
                    transform: `rotate(345deg)`
                }
                : {} }),
        react_1.default.createElement("div", { className: "flex flex-col items-start justify-center ml-[80px] gap-y-[8px]" }, (pollOptions === null || pollOptions === void 0 ? void 0 : pollOptions.length) > 0 &&
            pollOptions.map(({ id, option, count }, index) => {
                return (react_1.default.createElement("div", { className: "flex flex-row", key: id },
                    react_1.default.createElement("div", { className: "w-[16px] h-[16px] pr-[16px] mr-[12px] rounded-[50%]", style: { background: `var(--${colorTheme[index]}-400)` } }),
                    react_1.default.createElement("p", { className: "max-w-[540px] typography-h400 text-n-800 overflow-hidden", style: {
                            WebkitLineClamp: 2,
                            display: '-webkit-box',
                            WebkitBoxOrient: 'vertical',
                            overflowWrap: 'break-word'
                        } }, option),
                    react_1.default.createElement("p", { className: "typography-h200 text-n-600 text-left ml-[12px] w-[92px]" },
                        count,
                        " (",
                        react_1.default.createElement(FormattedNumber_1.default, { number: (count / voterCount) * 100, minDecimalLength: 0, customClass: "typography-h200" }),
                        "%)")));
            }))));
};
exports.default = MultipleChoice;
